var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Lib from '@core/libs';
var TCStructureNodeSelect = /** @class */ (function (_super) {
    __extends(TCStructureNodeSelect, _super);
    function TCStructureNodeSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.choiceSelects = [];
        _this.choiceSelectOptions = {};
        return _this;
    }
    TCStructureNodeSelect.prototype.onMounted = function () {
        var _this = this;
        this.el.querySelectorAll('select').forEach(function (select, index) {
            _this.choiceSelects.push(select);
            _this.choiceSelectOptions[select.id] = Array.from(select.options);
            select.addEventListener('change', function (e) {
                _this.onChoiceChanged(select);
            });
        });
        this.onChoiceChanged(this.choiceSelects[0]);
    };
    TCStructureNodeSelect.prototype.onChoiceChanged = function (select) {
        var selectedOption = null;
        var selectedOptionIndex = select.selectedIndex;
        if (selectedOptionIndex >= 0) {
            selectedOption = select.options[selectedOptionIndex];
        }
        if (!selectedOption) {
            return;
        }
        var parent = selectedOption.getAttribute('data-parent');
        var selectIndex = this.choiceSelects.indexOf(select);
        var nextSelect = selectIndex + 1 < this.choiceSelects.length ? this.choiceSelects[selectIndex + 1] : null;
        if (nextSelect) {
            this.refreshChoices(nextSelect, selectedOption.value);
        }
    };
    TCStructureNodeSelect.prototype.refreshChoices = function (select, parent) {
        var options = this.choiceSelectOptions[select.id];
        if (options) {
            options.forEach(function (option) {
                option.remove();
                if (option.getAttribute('data-parent') === parent) {
                    select.appendChild(option);
                }
            });
        }
        this.onChoiceChanged(select);
    };
    return TCStructureNodeSelect;
}(Lib));
export default TCStructureNodeSelect;
